import { Grid, Stack } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../../../router/Routes';
import { DrawerWidget, LoadingWidget } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { allBloquesPedagogicosAction } from '../bloques_pedagogicos/BloquesPedagogicosAction';
import { allHorariosAction } from '../horarios/HorariosAction';
import { allPlanEvaluacionAction } from '../plan_evaluacion/plan_evaluacion/PlanEvaluacionAction';
import { allBoletinesAction } from './BoletinesAction';
import { PARAMS_BOLETINES } from './BoletinesReducer';
import FiltrosBoletinesComponent from './components/FiltrosBoletines';
import ListadoBoletines from './components/ListadoBoletines';

const BoletinesView = () => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const boletinesStore = Redux.useSelector((state) => state.boletines);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [isFiltros, setIsFiltros] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      dispatch({
        type: PARAMS_BOLETINES,
        payload: {
          ...boletinesStore.params,
          idEntidad: entidadesStore.activo.id,
          idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
        },
      });

      if (
        bloquesPedagogicosStore.all &&
        bloquesPedagogicosStore.all.length === 0
      ) {
        await allBloquesPedagogicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      setIsFiltros(!boletinesStore.params.idSeccion);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    async function fetchData() {
      if (boletinesStore.params.idSeccion) {
        await allPlanEvaluacionAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
          idSeccion: boletinesStore.params.idSeccion,
          idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
        });
        await allBoletinesAction(dispatch, boletinesStore.params);
        await allHorariosAction({ dispatch }, boletinesStore.params);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boletinesStore.params.idSeccion]);

  return (
    <Grid container spacing={1}>
      {boletinesStore.loadingAll && (
        <Grid item md={12}>
          <LoadingWidget isLoading={boletinesStore.loadingAll} />
        </Grid>
      )}
      <Grid
        item
        md={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          {boletinesStore.all.length > 0 && (
            <BotonComponent
              text="EXPORTAR TODOS EN PDF"
              click={() => {
                history.push(ROUTES.boletinesPdf.to);
              }}
              red
              downloadIcon
            />
          )}
        </div>

        <Stack direction="row" justifyContent="flex-end">
          <BotonComponent
            text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
            click={() => setIsFiltros(!isFiltros)}
            white={!isFiltros}
            blue={isFiltros}
            filterIcon
            ml={2}
          />
        </Stack>
      </Grid>
      {boletinesStore.all.length > 0 && (
        <Grid item md={12}>
          {boletinesStore.all.length > 0 && <ListadoBoletines />}
        </Grid>
      )}
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosBoletinesComponent />
      </DrawerWidget>
    </Grid>
  );
};

export default BoletinesView;
